import { fontWeightName } from "@/lib/fontWeightLabels";

export function FontWeightLabel({ weight }: { weight: number }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="text-[11px] text-slate-500 tabular-nums">{weight}</span>
      <span>{fontWeightName(weight)}</span>
    </span>
  );
}
